import { Box, TextInput } from '@primer/react';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ComboboxPhongNamHoc from '../../components/combobox-phong-nam-hoc';
import Text from "../../components/ui/text";
import { useCommonContext } from '../../contexts/common';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { IPhongDiemDanhResponse } from '../../models/response/diem-danh/IPhongDiemDanhResponse';
import { BaoCaoDiemDanhResponse, DiemDanhResponse } from '../../models/response/diem-danh/DiemDanhResponse';
import { RootState } from '../../state/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { ePageBaseStatus } from '../../models/ePageBaseStatus';
import { actions } from '../../state/actions/actionsWrapper';
import DataTable from '../../components/ui/data-table';
import ComboBoxThang from '../../components/combobox-thang';
import { diemDanhApi } from '../../api/diemDanhApi';
import { IBaoCaoDiemDanhRequest } from '../../models/request/diem-danh/IDiemDanhPhongNamHocSelectRequest';
import { IColumn } from '../../components/ui/data-table/DataTable';
import Button from '../../components/ui/button';
import { PencilIcon, PlusIcon, SyncIcon, TrashIcon } from "@primer/octicons-react";
import { useTrangThaiDiemDanh } from '../../hooks/useTrangThaiDiemDanh';

const defaultLopDiemDanh: IPhongDiemDanhResponse = {
    phong_nam_hoc_id: 0,
    dm_truong_id: 0,
    nt_thoi_khoa_bieu_chi_tiet_id: 0,
    nt_tiet_id: 0,
    ten_phong: '',
    gio_diem_danh: ''
}
const today = new Date();


const DiemDanhHangNgayPage = () => {
    const { translate, checkAccesiableTo } = useCommonContext();
    const { tab } = useParams();
    const { nam_hoc, dm_he_id, dm_truong_id } = useCommonSelectedHook();
    const [phongDiemDanh, setPhongDiemDanh] = useState<IPhongDiemDanhResponse>(defaultLopDiemDanh);
    const [phongDiemDanhId, setPhongDiemDanhId] = useState<number>(0);
    const [tuNgay, setTuNgay] = useState<Date>(new Date(today.getFullYear(), today.getMonth(), 1));
    const [denNgay, setDenNgay] = useState<Date>(new Date(today.getFullYear(), today.getMonth() + 1, 0));
    const [baoCaoDiemDanh, setBaoCaoDiemDanh] = useState<any[]>([]);
    const {nt_diem_danh_trang_thais} = useTrangThaiDiemDanh();
    const dispatch = useDispatch();
    const defaultColumns: IColumn[] = [{
        caption: translate('Base.Label.StudentCode'),
        dataField: 'ma_hs',
        width: "100px",
        cellRender: (data: DiemDanhResponse) => {
            return (
                <Box>
                    <Box sx={{
                        color: "fg.muted"
                    }}>{data.ma_hs}</Box>
                </Box>
            );
        }
    },
    {
        caption: translate('Base.Label.StudentName'),
        dataField: 'ho_ten',
        width: "200px",
        cellRender: (data: BaoCaoDiemDanhResponse) => {
            return (
                <Box>
                    <Box><b>{data.ho_ten}</b></Box>
                    <Box>{moment(data.ngay_sinh).format('DD/MM/YYYY')}</Box>
                </Box>
            );
        }
    },
    {
        caption: translate('Base.Label.ClassName'),
        dataField: 'ten_lop',
        width: "80px",
        align: "center"
    },
    {
        caption: translate('Tổng'),
        dataField: 'tong',
        width: "150px",
        align: "center",
        cellRender: (data: any) => {
            let tongs: string[] = [];
            nt_diem_danh_trang_thais.map((val, i) => {
                var trangThaiTong = `${val.code}(${data[val.id] ?? 0})`;
                tongs.push(trangThaiTong);
            })
            return (
                <Box>
                    <Box>{tongs.join(", ")}</Box>
                </Box>
            );
        }
    }]
    const [cols, setCols] = useState<IColumn[]>([]);

    useEffect(() => {
        handleRefresh();
    }, [phongDiemDanh, tuNgay, denNgay])
    const handleRefresh = useCallback(() => {
        handlePhongNamHocRefresh()
    }, [phongDiemDanh, tuNgay, denNgay]);
    const handlePhongNamHocRefresh = useCallback(async () => {
        if (phongDiemDanh?.phong_nam_hoc_id > 0 && !!tuNgay && !!denNgay) {
            setCols(defaultColumns);
            var dates = getDatesBetween(tuNgay, denNgay);
            dates.map((val, index) => {
                if (val.getDay() > 0 && val.getDay() < 6) {
                    const dateCol: IColumn = {
                        caption: `${val.getDate()}`,
                        dataField: `date_${moment(val).format('YYYYMMDD')}`,
                        width: "40px",
                        align: "center",
                        columns: [
                            {
                                caption: `T${val.getDay() + 1}`,
                                dataField: `day_${moment(val).format('YYYYMMDD')}`,
                                width: "40px",
                                align: "center",
                            }
                        ]
                    }
                    setCols((prev) => [
                        ...prev,
                        dateCol
                    ])
                }
            })
            const request: IBaoCaoDiemDanhRequest = {
                noitru_phong_namhoc_id: phongDiemDanh?.phong_nam_hoc_id,
                nam_hoc: nam_hoc,
                tu_ngay: tuNgay,
                den_ngay: denNgay
            }
            var res = await diemDanhApi.SelectByThangAsync(request);
            if (res.is_success) {
                (res.data as any[]).map((val, index) => {
                    var diemDanhs = !!val.diem_danhs ? JSON.parse(val.diem_danhs) : [];
                    (diemDanhs as any[]).map((v, i) => {
                        res.data[index][`day_${moment(v.ngay_diem_danh).format('YYYYMMDD')}`] = v.code;
                        if(!!res.data[index][v.sis_diemdanh_status_id])
                            res.data[index][v.sis_diemdanh_status_id] = res.data[index][v.sis_diemdanh_status_id] + 1;
                        else
                            res.data[index][v.sis_diemdanh_status_id] = 1;
                    })
                })
                setBaoCaoDiemDanh(res.data);
            }
        }
    }, [phongDiemDanh, tuNgay, denNgay]);

    function getDatesBetween(start: Date, end: Date): Date[] {
        const dates: Date[] = [];
        const current = new Date(start);

        while (current <= end) {
            dates.push(new Date(current));
            current.setDate(current.getDate() + 1);
        }

        return dates;
    }

    return (
        <Box sx={{
            // p: 2
        }}>
            <Box id="toolbar" sx={{
                display: "flex",
                backgroundColor: "canvas.subtle",
                p: 2,
                borderBottomWidth: "1px",
                borderBottomStyle: "solid",
                borderBottomColor: "border.default",
                alignItems: "center"
            }}>
                <Box sx={{ ml: 1 }}>
                    <TextInput
                        leadingVisual={<Box>
                            <Text text="Từ ngày" />
                        </Box>}
                        type='date'
                        value={moment(tuNgay).format("YYYY-MM-DD")}
                        onChange={(e) => {
                            const dateSelected = e.target.value ? moment(e.target.value).toDate() : new Date();
                            setTuNgay(dateSelected);
                            // setPhongDiemDanh(defaultLopDiemDanh)
                        }}
                    />
                </Box>
                <Box sx={{ ml: 1 }}>

                    <TextInput
                        leadingVisual={<Box>
                            <Text text="Đến ngày" />
                        </Box>}
                        type='date'
                        value={moment(denNgay).format("YYYY-MM-DD")}
                        onChange={(e) => {
                            const dateSelected = e.target.value ? moment(e.target.value).toDate() : new Date();
                            setDenNgay(dateSelected);
                            // setPhongDiemDanh(defaultLopDiemDanh)
                        }}
                    />
                </Box>
                <Box sx={{ ml: 1 }}>
                    <ComboboxPhongNamHoc
                        onValueChanged={(dm_phong_id, phongs) => {
                            setPhongDiemDanh({
                                ...defaultLopDiemDanh,
                                phong_nam_hoc_id: dm_phong_id,
                            })
                            setPhongDiemDanhId(dm_phong_id ?? 0);
                        }}
                        value={phongDiemDanhId}

                    />

                </Box>
                <Box sx={{ ml: 1 }}>
                    <Button
                        variant="default"
                        onClick={handleRefresh}
                        leadingVisual={SyncIcon}
                        text="Base.Label.Refresh"

                    />

                </Box>
                <Box sx={{
                    flex: 1
                }}>

                </Box>
            </Box>
            <Box sx={{
                // p: 3,
                pb: 0
            }}>
                <Box sx={{ p: 3 }}>
                    <DataTable
                        columns={cols}
                        height={`${window.innerHeight - 230}px`}
                        data={baoCaoDiemDanh}
                        title={phongDiemDanh.ten_phong}
                        actionComponent={
                            <Box sx={{
                                display: "flex"
                            }}>


                            </Box>
                        }
                    />
                </Box>
            </Box>

        </Box>
    );
};

export default DiemDanhHangNgayPage;